module.exports = __webpack_public_path__ + "img/Profile-18.58b16bcb.png";